import { ImageModel } from './../models/imageModel';
import http from "../http-common";

class ImageDataService {

  async saveImage(object : {image: ImageModel}) {
    const json = JSON.stringify(object);
    return await http.post("/upload/image", json);
  }

  // Save the images to use carousel
  async saveCarouselImage(object : {image: ImageModel}) {
    const json = JSON.stringify(object);
    return await http.post("/carousel/image", json);
  }
  
  // Access the images from DB
  async getCarouselImages() {
    try {
      const response = await http.get("/carousel/images");
      const data = response.data;
  
      if (data.message === "Success") {
        return data.data;
      } else {
        console.error("Failed to fetch carousel images");
        return null;
      }
    } catch (error) {
      console.error("Error fetching carousel images:", error);
      return null;
    }
  }  

  // Delete all the images in carousel directory
  async deleteAllCarouselImages() {
    try {
      const response = await http.delete("/carousel/images");
      const data = response.data;

      if (data.message === "Success") {
        return data.data;
      } else {
        console.error("Failed to delete carousel images");
        return null;
      }
    } catch (error) {
      console.error("Error deleting carousel images:", error);
      return null;
    }
  }

  //   async saveImage(object : {image: ImageModel, type: string, id: String}) {
  //       const json = JSON.stringify(object);
  //       const { data } = await http.post("/upload/image", json);
  //       return data;
  //     }
}

export default new ImageDataService();